import { IHoliday } from "../holidayTypes";

  export const UKHolidays: { [key: string]: IHoliday } = {
    // 2024
    "2024-01-01": { title: "New Year's Day", type: "HOLIDAY" },
    "2024-03-29": { title: "Good Friday", type: "HOLIDAY" },
    "2024-04-01": { title: "Easter Monday", type: "HOLIDAY" },
    "2024-05-06": { title: "Early May Bank Holiday", type: "HOLIDAY" },
    "2024-05-27": { title: "Spring Bank Holiday", type: "HOLIDAY" },
    "2024-08-26": { title: "Summer Bank Holiday", type: "HOLIDAY" },
    "2024-12-25": { title: "Christmas Day", type: "HOLIDAY" },
    "2024-12-26": { title: "Boxing Day", type: "HOLIDAY" },

    // 2025
    "2025-01-01": { title: "New Year's Day", type: "HOLIDAY" },
    "2025-01-02": { title: "2nd January", type: "HOLIDAY" }, // Endast Skottland
    "2025-03-17": { title: "St. Patrick's Day", type: "HOLIDAY" }, // Endast Nordirland
    "2025-03-30": { title: "Mother's Day", type: "SPECIAL_DAY" },
    "2025-04-18": { title: "Good Friday", type: "HOLIDAY" },
    "2025-04-21": { title: "Easter Monday", type: "HOLIDAY" }, // Ej Skottland
    "2025-05-05": { title: "Early May Bank Holiday", type: "HOLIDAY" },
    "2025-05-26": { title: "Spring Bank Holiday", type: "HOLIDAY" },
    "2025-06-15": { title: "Father's Day", type: "SPECIAL_DAY" },
    "2025-07-13": { title: "Battle of the Boyne (Orangemen's Day)", type: "HOLIDAY" }, // Endast Nordirland
    "2025-08-04": { title: "Summer Bank Holiday", type: "HOLIDAY" }, // Endast Skottland
    "2025-08-25": { title: "Late Summer Bank Holiday", type: "HOLIDAY" }, // Ej Skottland
    "2025-10-31": { title: "Halloween", type: "SPECIAL_DAY" },
    "2025-11-05": { title: "Bonfire Night", type: "SPECIAL_DAY" },
    "2025-11-30": { title: "St. Andrew's Day", type: "HOLIDAY" }, // Endast Skottland
    "2025-12-24": { title: "Christmas Eve", type: "SPECIAL_DAY" },
    "2025-12-25": { title: "Christmas Day", type: "HOLIDAY" },
    "2025-12-26": { title: "Boxing Day", type: "HOLIDAY" },
    "2025-12-31": { title: "New Year's Eve", type: "SPECIAL_DAY" },

    // 2026
    "2026-01-01": { title: "New Year's Day", type: "HOLIDAY" },
    "2026-01-02": { title: "2nd January", type: "HOLIDAY" }, // Endast Skottland
    "2026-03-17": { title: "St. Patrick's Day", type: "HOLIDAY" }, // Endast Nordirland
    "2026-03-27": { title: "Mother's Day", type: "SPECIAL_DAY" },
    "2026-04-03": { title: "Good Friday", type: "HOLIDAY" },
    "2026-04-06": { title: "Easter Monday", type: "HOLIDAY" }, // Ej Skottland
    "2026-05-04": { title: "Early May Bank Holiday", type: "HOLIDAY" },
    "2026-05-25": { title: "Spring Bank Holiday", type: "HOLIDAY" },
    "2026-06-15": { title: "Father's Day", type: "SPECIAL_DAY" },
    "2026-07-13": { title: "Battle of the Boyne (Orangemen's Day)", type: "HOLIDAY" }, // Endast Nordirland
    "2026-08-03": { title: "Summer Bank Holiday", type: "HOLIDAY" }, // Endast Skottland
    "2026-08-31": { title: "Late Summer Bank Holiday", type: "HOLIDAY" }, // Ej Skottland
    "2026-10-31": { title: "Halloween", type: "SPECIAL_DAY" },
    "2026-11-05": { title: "Bonfire Night", type: "SPECIAL_DAY" },
    "2026-11-30": { title: "St. Andrew's Day", type: "HOLIDAY" }, // Endast Skottland
    "2026-12-24": { title: "Christmas Eve", type: "SPECIAL_DAY" },
    "2026-12-25": { title: "Christmas Day", type: "HOLIDAY" },
    "2026-12-26": { title: "Boxing Day", type: "HOLIDAY" },
    "2026-12-28": { title: "Substitute day for Boxing Day", type: "HOLIDAY" }, // Eftersom Boxing Day infaller på en lördag
    "2026-12-31": { title: "New Year's Eve", type: "SPECIAL_DAY" },

    // 2027
    "2027-01-01": { title: "New Year's Day", type: "HOLIDAY" },
    "2027-01-02": { title: "2nd January", type: "HOLIDAY" }, // Endast Skottland
    "2027-01-04": { title: "Substitute day for 2nd January", type: "HOLIDAY" }, // Endast Skottland
    "2027-03-07": { title: "Mother's Day", type: "SPECIAL_DAY" },
    "2027-03-17": { title: "St. Patrick's Day", type: "HOLIDAY" }, // Endast Nordirland
    "2027-03-26": { title: "Good Friday", type: "HOLIDAY" },
    "2027-03-29": { title: "Easter Monday", type: "HOLIDAY" }, // Ej Skottland
    "2027-05-03": { title: "Early May Bank Holiday", type: "HOLIDAY" },
    "2027-05-31": { title: "Spring Bank Holiday", type: "HOLIDAY" },
    "2027-06-20": { title: "Father's Day", type: "SPECIAL_DAY" },
    "2027-07-12": { title: "Battle of the Boyne (Orangemen's Day)", type: "HOLIDAY" }, // Endast Nordirland
    "2027-08-02": { title: "Summer Bank Holiday", type: "HOLIDAY" }, // Endast Skottland
    "2027-08-30": { title: "Late Summer Bank Holiday", type: "HOLIDAY" }, // Ej Skottland
    "2027-10-31": { title: "Halloween", type: "SPECIAL_DAY" },
    "2027-11-05": { title: "Bonfire Night", type: "SPECIAL_DAY" },
    "2027-11-30": { title: "St. Andrew's Day", type: "HOLIDAY" }, // Endast Skottland
    "2027-12-24": { title: "Christmas Eve", type: "SPECIAL_DAY" },
    "2027-12-25": { title: "Christmas Day", type: "HOLIDAY" },
    "2027-12-26": { title: "Boxing Day", type: "HOLIDAY" },
    "2027-12-27": { title: "Substitute day for Christmas Day", type: "HOLIDAY" },
    "2027-12-28": { title: "Substitute day for Boxing Day", type: "HOLIDAY" },
    "2027-12-31": { title: "New Year's Eve", type: "SPECIAL_DAY" }
  };




// WEBPACK FOOTER //
// ./src/constants/holidays/europe/ukHolidays.ts